/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type LinkOpsgeniePageType from '@jira/spa-apps__project-settings-link-opsgenie/src/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyLinkOpsgeniePage: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof LinkOpsgeniePageType
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-link-opsgenie-v2", jiraSpaEntry: "async-project-settings-link-opsgenie-v2" */ '@jira/spa-apps__project-settings-link-opsgenie/src/index.tsx'
		),
);

const AsyncLinkOpsgeniePage = (): React.JSX.Element => (
	<LazyPage Page={LazyLinkOpsgeniePage} pageId="link-opsgenie-page" shouldShowSpinner={false} />
);

export default AsyncLinkOpsgeniePage;
